export const snakeCaseToHumanLike = (str: string) => str.split("-").map(([firstLetter, ...restLetters]) => firstLetter.toUpperCase() + restLetters.join("")).join(" ");
